import { render, staticRenderFns } from "./Facture.vue?vue&type=template&id=6e75866a&"
import script from "./Facture.vue?vue&type=script&lang=js&"
export * from "./Facture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports